<section class="container" *ngIf="displayModal">
  <p-dialog
    [(visible)]="displayModal"
    modal="false"
    [draggable]="false"
    responsive="true"
    appendTo="body"
  >
    <p-header>
      <h3>{{ errorModalData.title }}</h3>
    </p-header>
    <p class="error-text m-t-xs">
      <i class="fa fa-exclamation-circle def error-icon"></i>{{ errorModalData.errorMessage }}
    </p>
    <p class="small m-t-md">
      We are experiencing difficulties in processing your request. Please try again!
    </p>
    <p-footer>
      <div class="buttons-container button-spacing text-center">
        <button class="btn btn-primary" (click)="closeModalAndSliders()" id="btn-default-236">
          Close
        </button>
      </div>
    </p-footer>
    <div *ngIf="isDebugModeOn">
      <br />
      <p class="small">{{ 'Session Id: ' + errorModalData.sessionId }}</p>
      <p class="small">{{ 'Interaction Id: ' + errorModalData.interactionId }}</p>
      <div *ngFor="let errorData of errorModalData.errors">
        <hr class="divider" />
        <p class="small">{{ 'API endpoint: ' + errorData.endpoint }}</p>
        <p class="small">{{ 'Error code: ' + errorData.code }}</p>
        <p class="small">{{ 'System Message: ' + errorData.systemMessage }}</p>
        <p class="small">{{ 'User Message: ' + errorData.userMessage }}</p>
      </div>
    </div>
  </p-dialog>
</section>
